module.exports = __webpack_public_path__ + "static/media/luminarium.bc684be5.jpg";